import React from "react"
import LinkButton from "@components/common/LinkButton"
import ProductSwiper from "./Carousel/ProductSwiper"
import { ArrowRight } from "@phosphor-icons/react"
import UseWindowSize from "@components/helpers/UseWindowSize"

const FeaturedSection = ({homeCollection}) => {
    const { width } = UseWindowSize()
    const products = homeCollection?.products;
    
    return (
        <React.Fragment>
            <section className="max-container grid grid-cols-1 md:grid-cols-7 gap-x-4 gap-y-6 mt-14">
                <div className="col-span-1 md:col-span-2 xl:col-span-2">
                    <h1>Wish You Were Here</h1>
                    {/* <h4>COLLECTION</h4> */}

                    <p className="mt-8">
						A love letter to carefree summers, unforgettable friendships, and the butterflies that come with something (or someone) new. With flirty silhouettes and prints made for memory-making, this collection is all about the moments — and the people — that make your summer unforgettable.
                    </p>

                    {/* <LinkButton
                        label={"View collection"}
                        icon={<ArrowRight size={20} weight="light" />}
                        className={"mt-4"}
                        to={`/collections/${homeCollection?.handle}`}
                    /> */}
                </div>

                <div className="col-span-1 md:col-span-5">
                    {width !== null && (
                        <ProductSwiper
                            products={products}
                            spaceBetween={10}
                            slidesPerView={3.5}
                            cardStyles={`w-40 lg:w-[262px]`}
                            breakpoints={{// value of key is min-width property
                                300: {
                                    slidesPerView: 1.8,
                                    spaceBetween: 5,
                                },
                                380: {
                                    slidesPerView: 2,
                                    spaceBetween: 5,
                                },
                                500: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 2.6,
                                },
                                769: {
                                    slidesPerView: 2,
                                },
                                900: {
                                    slidesPerView: 2,
                                },
                                1024: {
                                    slidesPerView: 2.5,
                                },
								1180: {
                                    slidesPerView: 3,
                                },
								1360: {
                                    slidesPerView: 3.5,
                                },
                                1440: {
                                    slidesPerView: 3.5,
                                },
							}}
							width={width <=  420 ? '160' : width <=  768 ? '194' : '262'}
                            height={width <=  420 ? '240' : width <=  768 ? '280' : '389'}
                            loop
                        />
                    )}
                </div>
            </section>
        </React.Fragment>
    );
}

export default FeaturedSection